module.exports = __webpack_public_path__ + "static/media/ddlooking.4aebf808.gif";